<div id="locker">
    <div class="container">
        <div class="back-button text-primary" (click)="back()">
            <mat-icon>keyboard_arrow_left</mat-icon>
            <span>{{ 'locker.cart.back' | translate }}</span>
        </div>
        <h1>{{ 'locker.cart.title' | translate }}</h1>
        @if (menu) {
          <app-locker-new-order (newOrder)="getOrders()"></app-locker-new-order>
          <app-locker-orders [orders]="orders" [menu]="menu"></app-locker-orders>
        }
    </div>
</div>